import { api } from "./api"

export const GET_ALL_TRIGGERS = async () => {
    const {data} = await api.get(`/triggers/all`)
    return data;
}

export const DELETE_TRIGGER = async (triggerId) => {
    const {data} = await api.delete(`/triggers/${triggerId}`)
    return data;
}

export const SAVE_TRIGGER = async (params) => {
    const {data} = await api.post(`/triggers/save`, params)
    return data;
}

export const SAVE_TRIGGER_ACTION = async (triggerId, params) => {
    const {data} = await api.post(`/triggers/${triggerId}/action`, params)
    return data;
}
